(function () {
  'use strict';

  /* @ngdoc object
   * @name costCenters.edit
   * @description
   *
   */
  angular
    .module('timeTracking.costCenters.edit', [
      'ui.router'
    ]);
}());
